import { Component } from '@angular/core';

@Component({
  selector: 'app-client-detail-edit',
  standalone: true,
  imports: [],
  templateUrl: './client-detail-edit.component.html',
  styleUrl: './client-detail-edit.component.css'
})
export class ClientDetailEditComponent {

}
